<template>
  <!--  新增能耗模型：工作时间设定-->
<div>
  <div>{{ Data.data.c_name }}</div>
  <div class=" row mb-2">
    <label class="col-sm-4 lh35 text-lr">工作时间：</label>
    <div class="col-sm-7 ">
      <el-time-picker style="width: 250px"
          is-range  @change="clickData"
          v-model="value" value-format="HH:mm" format="HH:mm"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围">
      </el-time-picker>
    </div>
  </div>
  <div class=" row mb-2">
    <label class="col-sm-4 lh35 text-lr">占比：</label>
    <div class="col-sm-7 ">
      <el-slider v-model="ratio"  @change="clickData"
                 show-input :max="1" :min="0" :step="0.001">
      </el-slider>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "workDay_block",
  props: ['Data'],
  data() {
    return {
      value:[this.Data.data.c_value.start_time,this.Data.data.c_value.end_time],
      ratio:this.Data.data.c_value.ratio,
    }
  },
  methods:{
    //选中值
    clickData() {
      var obj={}
      obj['start_time']=this.value[0]
      obj['end_time']=this.value[1]
      obj['ratio']=this.ratio
      this.$get_function(this.Data, obj)
    },
  },
}
</script>

<style scoped>

</style>